import { render, staticRenderFns } from "./meetingSummary.vue?vue&type=template&id=65a3030f&scoped=true&"
import script from "./meetingSummary.vue?vue&type=script&lang=js&"
export * from "./meetingSummary.vue?vue&type=script&lang=js&"
import style0 from "./meetingSummary.vue?vue&type=style&index=0&id=65a3030f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a3030f",
  null
  
)

export default component.exports